module.exports = __webpack_public_path__ + "static/media/SafEarth-Landing-Page-Logo.2b882a76.png";